export default __webpack_public_path__ + "static/media/regulatory--no-parking-or-no-stopping--g2.cbe40936.png";